import React, { useEffect } from 'react'
import Header from '../Header'
import Footer from '../Footer'

const Layout = ({ props, hideComp, children, ...rest }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    return (
        <div className="app-wrapper">
            {/* <h1>Hi {currentUser.name}!</h1> */}
            {!hideComp && <Header />}
            <div className={`main-container ${isBuyBestProject ? 'py-3' : ''}`}>{children}</div>
            {!hideComp && <Footer />}
        </div>
    )
}

export default Layout
